import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { RoundedLoader } from "./sharedSkeletonParts";

interface HorizontalBarListSkeletonProps {
  items?: number;
  labelWidth?: number;
  titleWidth?: number;
}

const TITLE_LINE_HEIGHT = 23;
const DEFAULT_TITLE_WIDTH = 240;
const LABEL_LINE_HEIGHT = 20;
const BAR_HEIGHT = 34;
const BAR_RADIUS = 4;
const VALUE_LINE_HEIGHT = 20;
const VALUE_WIDTH = 90;

const LABEL_WIDTHS = [80, 100, 70, 105, 60];
const BAR_WIDTHS = ["100%", "72%", "58%", "36%", "24%"];

export default function HorizontalBarListSkeleton({
  items = 5,
  labelWidth = 110,
  titleWidth = DEFAULT_TITLE_WIDTH,
}: Readonly<HorizontalBarListSkeletonProps>) {
  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm display-flex flex-column height-100pct">
      <div className="padding-bottom-20">
        <ContentLoader className="display-block" height={TITLE_LINE_HEIGHT} width={titleWidth} />
      </div>
      <div className="flex-1-1 display-flex flex-column justify-content-center gap-20 padding-15">
        {Array.from({ length: items }, (_, index) => (
          <div key={index} className="display-flex align-items-center gap-10">
            <span className="flex-0" style={{ width: labelWidth }}>
              <ContentLoader
                className="display-block"
                height={LABEL_LINE_HEIGHT}
                width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]}
              />
            </span>
            <div className="flex-1-1 display-flex align-items-center gap-10 min-width-0">
              <RoundedLoader height={BAR_HEIGHT} width={BAR_WIDTHS[index % BAR_WIDTHS.length]} radius={BAR_RADIUS} />
              <ContentLoader className="display-block" height={VALUE_LINE_HEIGHT} width={VALUE_WIDTH} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
